// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface District {
  caseNumber: string;
  cdn: string;
  courtName: string;
  district: string;
  district_Id: string;
  lastUpdatedOn: string;
  representative: string;
  status: string;
}

interface FormState {
  district: District | null;
}

const initialState: FormState = {
  district: null,
};

export const districtSlice = createSlice({
  name: 'district',
  initialState,
  reducers: {
    setDistrict: (state, action: PayloadAction<District>) => {
      state.district = action.payload;
    },
    clearDistrict: (state) => {
      state.district = null;
    },
  },
});

export const { setDistrict, clearDistrict } = districtSlice.actions;

export default districtSlice.reducer;
